import React, { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Divider,
  Button,
  MenuItem,
  Stack,
  ListItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import CustomInput from "../../components/inputs/CustomInput";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxInDesktop";
import TimeRangeSelector from "../../components/layouts/common/TimeRangeSelector";
import { getCampApi } from "../../apis/camp.api";
import { StyledSearchBar } from "../../components/inputs/SearchBar";
import {
  getCityApi,
  getCountryApi,
  getStateApi,
} from "../../apis/CountryStateCity.api";
import { getProductApi } from "../../apis/product.api";
import { getUserApi } from "../../apis/user.api";

// Your existing components
// import AsyncDropDown from "./AsyncDropDown";
// import CustomInput from "./CustomInput";

const drawerWidth = 400;

const DrawerFilter = ({
  open,
  onClose,
  onApply,
  onClear,
  filters = {},
  setFilters,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const handleApply = () => {
    if (onApply) onApply(localFilters);
    // onClose();
  };

  const handleClear = () => {
    // if (onClear) {
    //   onClear();
    // } else {
    setLocalFilters({
      ...localFilters,
      camp: "",
      camp_name: "",
      country: "",
      taluka: "",
      state: "",
      district: "",
      user: "",
      user_name: "",
    });
    // }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => onClose(localFilters)}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: drawerWidth },
          bgcolor: "#f3f4f6",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #162f5c, #0E2548, #2f5fb3)",
          color: "#fff",

          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ ml: 1 }} variant="body1" fontWeight={600}>
          Filters
        </Typography>

        <IconButton
          onClick={handleApply}
          size="small"
          sx={{
            bgcolor: "rgba(255,255,255,0.15)",
            color: "#fff",
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, p: 3, overflowY: "auto" }}>
        <Box mb={3}>
          <Typography variant="body2" fontWeight={400} color="#173F7A" mb={1}>
            User
          </Typography>

          <PaddingBoxInDesktop
            mb={2}
            sx={{
              width: "100%",
              display: "flex",
            }}
          >
            <AsyncDropDown
              Value={
                localFilters?.user
                  ? {
                      _id: localFilters?.user?._id || localFilters?.user,
                      name: localFilters?.user?.name || localFilters?.user_name,
                    }
                  : null
              }
              lazyFun={async (para) => {
                return await getUserApi({ ...para, team: true });
              }}
              OptionComponent={({ option, ...rest }) => {
                return (
                  <MenuItem {...rest} sx={{ textTransform: "capitalize" }}>
                    {option.name}
                  </MenuItem>
                );
              }}
              onChange={async (changedVal) => {
                setLocalFilters({
                  ...localFilters,
                  user: changedVal ? changedVal._id : null,
                  user_name: changedVal ? changedVal.name : null,
                });
              }}
              titleKey={"name"}
              valueKey={"_id"}
              InputComponent={(params) => (
                <CustomInput placeholder={"Select User*"} {...params} />
              )}
            />
          </PaddingBoxInDesktop>
        </Box>
        <Box mb={3}>
          <Typography variant="body2" fontWeight={400} color="#173F7A" mb={1}>
            Camp
          </Typography>

          <PaddingBoxInDesktop
            mb={2}
            sx={{
              width: "100%",
              display: "flex",
            }}
          >
            <AsyncDropDown
              sx={{ width: "100%" }}
              Value={
                localFilters?.camp
                  ? { _id: localFilters.camp, name: localFilters.camp_name }
                  : null
              }
              lazyFun={async (para) =>
                await getCampApi({ ...para, allStatus: true })
              }
              OptionComponent={({ option, ...rest }) => (
                <ListItem {...rest}>{option.name}</ListItem>
              )}
              onChange={async (changedVal) => {
                setLocalFilters({
                  ...localFilters,
                  camp: changedVal ? changedVal._id : null,
                  camp_name: changedVal ? changedVal?.name : null,
                });
              }}
              titleKey="name"
              valueKey="_id"
              InputComponent={(params) => (
                <CustomInput
                  {...params}
                  placeholder="Select Camp"
                  margin="none"
                  fullWidth
                />
              )}
            />
          </PaddingBoxInDesktop>
        </Box>
        {/* <Box mb={3}>
          <Typography variant="body2" fontWeight={400} color="#173F7A" mb={1}>
            Country
          </Typography>
          <PaddingBoxInDesktop
            mb={2}
            sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}
          >
            <AsyncDropDown
              // key={filters.district}
              // disabled={!}
              Value={
                localFilters?.country
                  ? { _id: 1, name: localFilters?.country }
                  : null
              }
              lazyFun={async (para) =>
                await getCountryApi({
                  ...para,
                  allStatus: true,
                  isName: true,
                })
              }
              OptionComponent={({ option, ...rest }) => {
                return <ListItem {...rest}>{option.name}</ListItem>;
              }}
              onChange={async (changedVal) => {
                setLocalFilters((prev) => ({
                  ...prev,
                  country: changedVal?.name || "",
                  taluka: "",
                  state: "",
                  district: "",
                  // cityName: "",
                }));
              }}
              titleKey={"name"}
              valueKey={"_id"}
              InputComponent={(params) => (
                <CustomInput
                  placeholder={"Select Country"}
                  label={"Country"}
                  {...params}
                  margin="none"
                />
              )}
            />
          </PaddingBoxInDesktop>
        </Box>
        <Box mb={3}>
          <Typography variant="body2" fontWeight={400} color="#173F7A" mb={1}>
            State
          </Typography>

          <PaddingBoxInDesktop
            mb={2}
            sx={{
              width: "100%",
              display: "block",
              p: 0, // remove all padding
              pl: "0 !important",
              pr: "0 !important",
              m: 0,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <AsyncDropDown
                key={localFilters.state}
                Value={
                  localFilters?.state
                    ? { _id: 1, name: localFilters?.state }
                    : null
                }
                lazyFun={async (para) =>
                  await getStateApi({
                    ...para,
                    allStatus: true,
                    country: localFilters?.country,
                    isName: true,
                  })
                }
                OptionComponent={({ option, ...rest }) => (
                  <ListItem {...rest}>{option.name}</ListItem>
                )}
                onChange={async (changedVal) => {
                  setLocalFilters((prev) => ({
                    ...prev,
                    state: changedVal?.name || "",
                    district: "",
                  }));
                }}
                titleKey="name"
                valueKey="_id"
                InputComponent={(params) => (
                  <CustomInput
                    {...params}
                    placeholder="Select State"
                    // label="State"
                    margin="none"
                    fullWidth
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </Box>
          </PaddingBoxInDesktop>
        </Box>

        <Box mb={3}>
          <Typography variant="body2" fontWeight={400} color="#173F7A" mb={1}>
            District
          </Typography>

          <PaddingBoxInDesktop
            mb={2}
            sx={{
              width: "100%",
              display: "block",
              p: 0,
              pl: "0 !important",
              pr: "0 !important",
              m: 0,
            }}
          >
            <Box sx={{ width: "100%" }}>
              <AsyncDropDown
                key={localFilters.state}
                disabled={!localFilters.state}
                Value={
                  localFilters?.district
                    ? { _id: 3, name: localFilters?.district }
                    : null
                }
                lazyFun={async (para) =>
                  await getCityApi({
                    ...para,
                    allStatus: true,
                    state: localFilters.state,
                    isName: true,
                  })
                }
                OptionComponent={({ option, ...rest }) => (
                  <ListItem {...rest}>{option.name}</ListItem>
                )}
                onChange={async (changedVal) => {
                  setLocalFilters((prev) => ({
                    ...prev,
                    district: changedVal?.name || "",
                  }));
                }}
                titleKey="name"
                valueKey="_id"
                InputComponent={(params) => (
                  <CustomInput
                    {...params}
                    placeholder="Select District"
                    // label="District"
                    margin="none"
                    fullWidth
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </Box>
          </PaddingBoxInDesktop>
        </Box> */}
      </Box>

      <Divider />

      <Box
        sx={{
          p: 2,
          bgcolor: "#f3f4f6",
        }}
      >
        <Stack direction="row" spacing={1.5} gap={2}>
          <Button
            variant="outlined"
            fullWidth
            onClick={handleClear}
            sx={{
              height: 38,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 400,
              fontSize: 18,
              color: "#173F7A",
              borderColor: "#d0d5dd",
              bgcolor: "#fff",
            }}
          >
            Clear
          </Button>

          <Button
            variant="contained"
            fullWidth
            onClick={handleApply}
            sx={{
              height: 38,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 400,
              fontSize: 18,
              bgcolor: "#173F7A",
              "&:hover": {
                bgcolor: "#0f2d59",
              },
            }}
          >
            Apply
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
};

export default DrawerFilter;
